import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui/select';
import { Label } from '@/shared/ui/label';
import { Project } from '../types';

interface ProjectSelectorProps {
  projects: Project[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export const ProjectSelector: React.FC<ProjectSelectorProps> = ({
  projects,
  value,
  onChange,
  disabled,
  isLoading,
}) => {
  const hasNoProjects = !isLoading && !disabled && projects.length === 0;
  
  return (
    <div className="space-y-2">
      <Label htmlFor="project">Project</Label>
      <Select
        value={value}
        onValueChange={onChange}
        disabled={disabled || isLoading || hasNoProjects}
      >
        <SelectTrigger id="project">
          <SelectValue 
            placeholder={
              isLoading 
                ? "Loading..." 
                : hasNoProjects 
                  ? "No active projects for selected client"
                  : "Select a project"
            } 
          />
        </SelectTrigger>
        <SelectContent className="max-h-[300px] overflow-y-auto">
          {projects.length === 0 ? (
            <div className="px-2 py-6 text-sm text-center text-muted-foreground">
              No active projects available
            </div>
          ) : (
            projects.map((project) => (
              <SelectItem key={project.id} value={project.id.toString()}>
                {project.name}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

